import { render, staticRenderFns } from "./NavHeader.vue?vue&type=template&id=7f745094"
import script from "./NavHeader.vue?vue&type=script&lang=js"
export * from "./NavHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/alidata/server/jenkins/workspace/sunion-test-web-os/03SRC/web-os/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f745094')) {
      api.createRecord('7f745094', component.options)
    } else {
      api.reload('7f745094', component.options)
    }
    module.hot.accept("./NavHeader.vue?vue&type=template&id=7f745094", function () {
      api.rerender('7f745094', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/layout/NavHeader.vue"
export default component.exports